import Client from "./_client";

export const getTemplateQuestionsById = async (id) => {
  const result = await new Client({
    path: `/sepTemplate/${id}/questions`,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get questions. Please try again!"
    );
  }

  return result?.data;
}

export const getTemplateId = async (id) => {
  const result = await new Client({
    path: `/sepTemplate/${id}`,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get Template. Please try again!"
    );
  }

  return result?.data;
}